module.exports = __webpack_public_path__ + "img/receive_bg_ful.8604f258.png";